import { lazy, Suspense } from 'react'

import { CardCustomizationBlocker } from '@cash-web/protos/squareup/franklin/blockers/card_customization_blocker.pb'
import { useExperiment } from '@cash-web/shared-data-access-experiments'
import { useFlowContext } from '@cash-web/shared-flow-data-access-context'
import { isMobileDevice } from '@cash-web/shared-util-user-agent'

const isMobile = isMobileDevice()

const CardStudio = lazy(() =>
  import('@cash-web/shared-card-studio-feature-main').then(module => ({ default: module.CardStudio }))
)

export const BlockerCardCustomization = ({ blocker }: { blocker: CardCustomizationBlocker }) => {
  const flow = useFlowContext()
  const mobileCardStudioEnabled = useExperiment('cash-web-mobile-card-studio')?.variant_value === 'treatment'

  // Some mobile web flows may return the card_customization blocker. While mweb card studio is still in development,
  // we will show the error page.
  if (isMobile && !mobileCardStudioEnabled) {
    throw new Error('Mobile card studio is not enabled. Flow: ' + flow.active?.trackingFlowName)
  }

  return (
    <Suspense fallback={null}>
      <CardStudio />
    </Suspense>
  )
}
